import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {SharedStoreFacade} from '../../../../../shared/shared/store/shared-store.facade';
import * as SharedSelectors from '../../../../../shared/shared/store/shared-store.selector';
import {DocumentTypeFormModalComponent} from '../../../../general-modals/document-type-form-modal/document-type-form-modal.component';
import {IDocumentTypesDto} from '../../../dto/document-listing.dto';

@Component({
  selector: 'app-create-cc-by-ai-form',
  standalone: false,
  templateUrl: './create-cc-by-ai-form.component.html',
  styleUrl: './create-cc-by-ai-form.component.scss',
})
export class CreateCcByAiFormComponent {

    @Input({required:true}) uploadFileForm: FormGroup;
    @Input({required:true}) processingPDF: boolean = false;
    @Input({required:true}) documentTypes: IDocumentTypesDto[];
    @Input({required:true}) formSubmitted: boolean = false;
    
    @Input() maxFileSize: number =  20 * 1024 * 1024;
    @Input() acceptableFiles = ["application/pdf"];

    public isDocumentTypesLoading$ :Observable<boolean>  = this._store.select(SharedSelectors.isDocumentTypesLoading);

    constructor(private _modalService: NgbModal, private _sharedStoreFacade: SharedStoreFacade, private _store: Store) {
    }
    
    onFileDropped($event: Event) {
        let csvFile: FileList= null
        if ($event instanceof Event) {
            csvFile = (($event.target as HTMLInputElement).files) as unknown as FileList;
        } else {
            csvFile = $event as unknown as FileList;
        }
        
        this.uploadFileForm.patchValue({
            file: csvFile.item(0)
        });
        
        this.uploadFileForm.markAsTouched();
        this.uploadFileForm.markAsDirty();
    }

    deleteFile() {
        this.uploadFileForm.patchValue({
            file: null
        })
    }

    addNewDocumentType() {
        const documentTypeModalRef$ = this._modalService.open(DocumentTypeFormModalComponent);
        documentTypeModalRef$.result.then((data) => {
            if (data.success == 1) {
                this._sharedStoreFacade.updateDocumentTypesList([ data.data])
                this.uploadFileForm.patchValue({ document_type_id: data.data.id });
            }
        });
    }
}
